import { Toggle } from 'components/CheckboxToggle/types/Toggle';
import {
  CUSTOM_WARNING,
  PALETTE_BLUE_400,
  PALETTE_ERROR_MAIN,
  PALETTE_NEUTRAL_LIGHT,
  PALETTE_WARNING_MAIN,
} from 'utils/colours';

export const initialFrameHealthToggleState: Toggle[] = [
  {
    filter: 'mia',
    value: 'MIA',
    active: true,
    color: PALETTE_ERROR_MAIN,
  },
  {
    filter: 'inError',
    value: 'Error',
    active: true,
    color: PALETTE_WARNING_MAIN,
  },
  {
    filter: 'lowDelivery',
    value: 'Low Delivery',
    active: true,
    color: CUSTOM_WARNING,
  },
  {
    filter: 'ok',
    value: 'OK',
    active: true,
    color: PALETTE_BLUE_400,
  },
  {
    filter: 'deactivated',
    value: 'Deactivated',
    active: true,
    color: PALETTE_NEUTRAL_LIGHT,
  },
];
